var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createAsyncThunk, createSelector, createSlice, } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { getEventTracker, sendPatientInformationData } from 'hx-analytics';
export var WIZARD_FEATURE_KEY = 'wizard';
export var defaultInitialWizardState = {
    status: 'idle',
    form: {},
};
var sendData = createAsyncThunk('wizard/sendData', function (payload, _a) {
    var getState = _a.getState, rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var state, trackCustom, error_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    state = getState();
                    trackCustom = getEventTracker().trackCustom;
                    trackCustom('patient_information', { data: state.wizard.form });
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, sendPatientInformationData({
                            data: state.wizard.form,
                            sessionId: state.widget.sessionId,
                            source: ((_b = state.widget.hostDetails) === null || _b === void 0 ? void 0 : _b.source) || {
                                origin: window.location.origin,
                                hostname: window.location.hostname,
                            },
                        })];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    console.error(error_1);
                    // if (process.env.REACT_APP_SENTRY_DSN) {
                    //   Sentry.captureException(error);
                    // }
                    return [2 /*return*/, rejectWithValue(error_1)];
                case 4: return [2 /*return*/];
            }
        });
    });
});
export var createWizardStore = function (initialWizardState) {
    if (initialWizardState === void 0) { initialWizardState = defaultInitialWizardState; }
    var wizardSlice = createSlice({
        name: WIZARD_FEATURE_KEY,
        initialState: initialWizardState,
        reducers: {
            update: function (state, action) { return (__assign(__assign({}, state), { form: __assign(__assign({}, state.form), action.payload) })); },
            reset: function (state) { return initialWizardState; },
        },
        extraReducers: function (builder) {
            builder
                .addCase(sendData.pending, function (state) {
                if (state.status === 'idle') {
                    state.status = 'pending';
                }
            })
                .addCase(sendData.fulfilled, function (state) {
                if (state.status === 'pending') {
                    state.status = 'idle';
                    state.error = undefined;
                }
            })
                .addCase(sendData.rejected, function (state, action) {
                if (state.status === 'pending') {
                    state.status = 'idle';
                    state.error = action.error;
                }
            });
        },
    });
    var wizardStoreReducer = wizardSlice.reducer;
    var wizardActions = __assign(__assign({}, wizardSlice.actions), { sendData: sendData });
    return {
        WIZARD_FEATURE_KEY: WIZARD_FEATURE_KEY,
        wizardSlice: wizardSlice,
        wizardStoreReducer: wizardStoreReducer,
        wizardActions: wizardActions,
    };
};
var selectWizard = function (state) { return state.wizard; };
export var volumeSelector = createSelector(selectWizard, function (state) {
    return state.form.volume;
});
export var firstEarSelector = createSelector(selectWizard, function (state) {
    return state.form['first-ear'];
});
export var useWizardSelector = useSelector;
